module.exports = __webpack_public_path__ + "static/media/Firma ltv.af8c5acd.svg";